import DiagnoseSelect from './DiagnoseSelect';
import DiagnoseSelectUI from './DiagnoseSelectUI';

export default DiagnoseSelect;

export { DiagnoseSelectUI };
